import React from "react";
import { useSelector } from "react-redux";
import Feature from "../feature";
import AuthFeature from "../authFeature";

const ALLRoutes: React.FC = () => {
  const token = useSelector((state: any) => state.auth.token);
  const isAuthenticated = !!token;

  //.log("isAuthenticated:", isAuthenticated);

  return isAuthenticated ? <Feature /> : <AuthFeature />;
};

export default ALLRoutes;
